import React from 'react'
import styled from 'styled-components'

const Root = styled.div`
  position: sticky;
  top: 0;
  z-index: 20;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid #e5e7eb;
  padding: 10px 32px;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  min-height: 40px;
`

const Left = styled.div`
  justify-self: start;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`

const Center = styled.div`
  justify-self: center;
  display: flex;
  align-items: center;
  gap: 12px;
`

const Right = styled.div`
  justify-self: end;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`

export function ChildAppTopbar({ left, center, right, style }) {
  return (
    <Root style={style}>
      <Grid>
        <Left>{left}</Left>
        <Center>{center}</Center>
        <Right>{right}</Right>
      </Grid>
    </Root>
  )
}

